<template>
  <div class="pagination-update">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :current-page.sync="currentPage"
      :page-size="limit"
      :total="total"
      :small="small">
    </el-pagination>
  </div>
</template>

<script>
  export default {
    name: "pagination",
    data() {
      return {
        currentPage: 1
      }
    },
    props: {
      total: {
        required: false,
        default: 0
      },
      limit: {
        required: false,
        default: 10
      },
      small: {
        required: false,
        type: Boolean,
        default: false
      }
    },
    watch: {
      currentPage (val) {
        if (typeof val === "number") {
          this.currentPage = val
        }
      },
    },
    methods: {
      // 当前页变化
      handleCurrentChange (val) {
        this.$emit("handleCurrentChange", val)
      },
      // size变化
      handleSizeChange (val) {
        this.currentPage = 1
        this.$emit('handleSizeChange', val)
      }
    }
  }
</script>

<style lang="scss">
  .pagination-update {
    margin: 20px 0;
    text-align: center;
    .el-icon-arrow-right:before {
      background: none;
      content: "\e6e0" !important;
    }
  }
</style>